(() => {
  const init = () => document.querySelectorAll('[data-apparel-root]').forEach(root => {
    if (root.dataset.sizeGuardReady) return;
    const group = root.querySelector('[data-size-required]');
    const form = root.querySelector('.aa-form');
    const button = root.querySelector('[data-apparel-add]');
    if (!group || !form || !button) return;
    root.dataset.sizeGuardReady = 'true';
    const text = button.querySelector('[data-add-text]');
    const price = button.querySelector('[data-add-price]');
    const label = group.querySelector('[data-option-label]');
    const error = root.querySelector('[data-size-error]');
    root.dataset.sizeChosen = 'false';
    group.querySelectorAll('[data-option-value]').forEach(option => option.setAttribute('aria-pressed', 'false'));
    label.textContent = root.dataset.chooseSize;
    const refresh = () => {
      if (root.dataset.sizeChosen !== 'true') {
        text.textContent = root.dataset.chooseSize;
        price.textContent = '';
      }
      const context = root.querySelector('[data-tw-sticky-context]');
      if (context) {
        const selected = group.querySelector('[aria-pressed="true"]');
        const colour = root.querySelector('[data-option-position="1"] [aria-pressed="true"]');
        const summary = root.dataset.sizeChosen === 'true' && selected
          ? [selected.textContent.trim(), colour?.dataset.displayValue].filter(Boolean).join(' · ')
          : '';
        if (context.textContent !== summary) context.textContent = summary;
      }
    };
    refresh();
    // A colour change may rerender the ordinary add label; keep the size gate visible.
    group.parentElement.addEventListener('click', event => {
      if (!event.target.closest('[data-option-value]')) return;
      if (event.target.closest('[data-size-required]')) {
        root.dataset.sizeChosen = 'true';
        group.classList.remove('has-size-error');
        error.hidden = true;
      }
      queueMicrotask(refresh);
    });
    form.addEventListener('submit', event => {
      if (root.dataset.sizeChosen === 'true') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      group.classList.add('has-size-error');
      error.hidden = false;
      group.scrollIntoView({ block: 'center', behavior: 'auto' });
      group.querySelector('[data-option-value]')?.focus({ preventScroll: true });
    }, true);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
